import React from "react";
import {
  BlazingFastSpeedsIcon,
  CustomerSupportIcon,
  EasyToUseIcon,
  GlobalContentIcon,
  StayAnonymousOnlineIcon,
  UnmatchPrivacyProtectionIcon,
} from "../../../assets/icons";
import EssentialFeature from "./EssentialFeature";

export default function EssentialFeaturesList() {
  const features = [
    {
      title: "Unmatched Privacy Protection",
      description:
        "Keep your personal data safe with military-grade encryption that shields you from hackers and prying eyes.",
      icon: <UnmatchPrivacyProtectionIcon />,
    },
    {
      title: "Unlimited Access to Global Content",
      description:
        "Bypass geo-restrictions and enjoy your favorite streaming services, websites, and apps from anywhere in the world.",
      icon: <GlobalContentIcon />,
    },
    {
      title: "Blazing-Fast Speeds",
      description:
        "Experience high-speed servers that ensure smooth browsing, streaming, and downloading without any interruptions.",
      icon: <BlazingFastSpeedsIcon />,
    },
    {
      title: "Stay Anonymous Online",
      description:
        "Browse the web without leaving a trace. Geo VPN hides your IP address and ensures your activities remain private.",
      icon: <StayAnonymousOnlineIcon />,
    },
    {
      title: "Easy to Use",
      description:
        "One-click setup and intuitive interface make Geo VPN accessible for everyone—from tech novices to experts.",
      icon: <EasyToUseIcon />,
    },
    {
      title: "24/7 Customer Support",
      description:
        "Get instant help and support whenever you need it with our dedicated team of professionals.",
      icon: <CustomerSupportIcon />,
    },
  ];

  return (
    <section className="grid grid-cols-2 gap-4 md:gap-5 2xl:gap-6">
      {features.map((feature, index) => (
        <div
          key={index}
          className="h-full rounded-2xl bg-[#F6F8FE] border border-blue-50/60 shadow-sm hover:shadow-md transition-shadow"
        >
          <EssentialFeature
            title={feature.title}
            description={feature.description}
            icon={feature.icon}
          />
        </div>
      ))}
    </section>
  );
}
